export const orderNowConfig = {
  coupon: 'VMD6EG',
  coupon_value: 8,
  MEALS_DEFAULT: 0,
  PEOPLE_DEFAULT: 2,
  DISCOUNT: 10,
  FREE_DELIVERY_FROM: 34,
  PEOPLE_OFFER: [2, 4],
  MAX_ITEM: 999,
  EXTRA_QUERY: {
    show: 50,
    page: 1,
    sort_direction: 'asc',
    query: `shopTags.name in ('Cassette') and id not in (4972, 4137, 4124, 3228,3227,3229)`,
    'productables': true
  },
  recurring: true,
  addToCartText: 'Aggiungi al carrello una cassetta per procedere con il tuo ordine!',
  header_background: {
    backgroundImage: "url('https://api.quomi.it/oldimg/cassette-di-frutta-e-verdura-bio-a-domicilio-quomi.webp')"
  },
  top_banner_color:{ 
    backgroundColor: 'var(--quomi-primary)'
  },
  cta_background: {
    backgroundColor: 'var(--quomi-primary)'
  },
  payoff: {
    title: 'Le cassette di frutta e verdura a casa tua',
    subtitle: 'Il tuo viaggio di gusto e benessere inizia da qui',
    subtitle_2: 'Per te 40€ di sconto sui primi 5 ordini',
    subtitle_3: `Approfittane ora, l'offerta scade questa settimana!`
  },
  how_works: {
    subtitle: 'Scegli il benessere con le cassette di frutta e verdura Quomi. Solo prodotti certificati e da agricoltura sostenibile!',
    card_1: {
      img: 'https://api.quomi.it/oldimg/Comefunziona1.png',
      title: '1. Scegli la tua cassetta',
      subtitle: 'Scegli la tua cassetta preferita di frutta e verdura o mista'
    },
    card_2: {
      img: 'https://api.quomi.it/oldimg/Cassette-di-Frutta-per-le-aziende-Quomi.webp',
      title: '2. Senza vincoli',
      subtitle: `Ordina quando vuoi o attiva l'abbonamento`
    },
    card_3: {
      img: 'https://api.quomi.it/oldimg/Comefunziona3.png',
      title: '3. Consegna a domicilio',
      subtitle: 'Ricevi la tua cassetta comodamente a casa tua'
    }
  },
  steps: {
    title:'Perfette per chi cerca frutta e verdura di qualità,<br> con la comodità della consegna a domicilio!',
    subtitle: 'Per te 40€ di sconto sui primi 5 ordini',
    step_title_1: 'Scegli la tua cassetta',
    step_title_2: 'Crea il tuo account',
    step_title_3: 'Dove vuoi ricevere la tua prima cassetta?',
    step_title_4: 'Abbonati e risparmia',
    step_title_5: 'Modalità di pagamento',
  }
}